module.exports = {
  ENTERED_WIZARD: 'ENTERED_WIZARD',
  CREATE_REQUEST_ID: 'CREATE_REQUEST_ID',
};
